import { all, takeEvery, put } from 'redux-saga/effects';
import siteConfig from '@iso/config/site.config';
import actions from './actions';
import { notification } from '@iso/components';
const gaxios = require('gaxios');
gaxios.instance.defaults = {
    baseURL: siteConfig.siteUrl.API_URL
}

export function* downloadFacturas({ payload }) {
    const res = yield gaxios.request({
        url: 'api/download/facturas/facturacion/',
        method: 'POST',
        data: payload,
    });

    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({ type: actions.DOWNLOAD_FACTURAS_SUCCESS, payload: res.data.url });
    }
}

export function* downloadInformeVentas({ payload }) {
    const res = yield gaxios.request({
        url: 'api/download/facturas/ventas/',
        method: 'POST',
        data: payload,
    });

    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({ type: actions.DOWNLOAD_INFORME_VENTAS_SUCCESS, payload: res.data.url });
    }
}

export function* downloadInformeCartera({ payload }) {
    console.log("yo")
    const res = yield gaxios.request({
        url: 'api/download/cartera/',
        method: 'POST',
        data: payload,
    });

    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({ type: actions.DOWNLOAD_INFORME_CARTERA_SUCCESS, payload: res.data.url });
    }
}

export function* downloadRemisiones({ payload }) {
    const res = yield gaxios.request({
        url: 'api/download/facturas/',
        method: 'POST',
        data: payload,
    });

    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({ type: actions.DOWNLOAD_REMISIONES_SUCCESS, payload: res.data.url });
    }
}

export function* downloadInformeCompras({ payload }) {
    const res = yield gaxios.request({
        url: 'api/download/informe-compras/',
        method: 'POST',
        data: payload,
    });

    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        yield put({ type: actions.DOWNLOAD_INFORME_COMPRAS_SUCCESS, payload: res.data.url });
    }
}

export function* downloadCaja({ payload, tipo }) {
    const url = tipo === 'egresos-compras'? 'api/download/egresosCompras/' :'api/download/caja/';
    const res = yield gaxios.request({
        url,
        method: 'POST',
        data: payload,
    });

    if (!res.data.success) {
        notification('error', res.data.msg);
    } else {
        if (tipo === 'ingresos-efectivo') {
            yield put({ type: actions.INGRESOS_EFECTIVO, payload: res.data.url });
        }
        
        if (tipo === 'ingresos-davivienda') {
            yield put({ type: actions.INGRESOS_DAVIVIENDA, payload: res.data.url });
        }

        if (tipo === 'ingresos-bancolombia') {
            yield put({ type: actions.INGRESOS_BANCOLOMBIA, payload: res.data.url });
        }
        
        if (tipo === 'ingresos-caja-codice') {
            yield put({ type: actions.INGRESOS_CAJA_CODICE, payload: res.data.url });
        }

        if (tipo === 'egresos-efectivo') {
            yield put({ type: actions.EGRESOS_EFECTIVO, payload: res.data.url });
        }

        if (tipo === 'egresos-davivienda') {
            yield put({ type: actions.EGRESOS_DAVIVIENDA, payload: res.data.url });
        }

        if (tipo === 'egresos-bancolombia') {
            yield put({ type: actions.EGRESOS_BANCOLOMBIA, payload: res.data.url });
        }

        if (tipo === 'egresos-compras') {
            yield put({ type: actions.EGRESOS_COMPRAS, payload: res.data.url });
        }

        if (tipo === 'egresos-caja-codice') {
            yield put({ type: actions.EGRESOS_CAJA_CODICE, payload: res.data.url });
        }
        
        if (tipo === 'ingresos-efectivo-tus-cupos') {
            yield put({ type: actions.INGRESOS_EFECTIVO_TUS_CUPOS, payload: res.data.url });
        }

        if (tipo === 'ingresos-caja-tus-cupos') {
            yield put({ type: actions.INGRESOS_CAJA_TUS_CUPOS, payload: res.data.url });
        }

        if (tipo === 'egresos-efectivo-tus-cupos') {
            yield put({ type: actions.EGRESOS_EFECTIVO_TUS_CUPOS, payload: res.data.url });
        }

        if (tipo === 'egresos-caja-tus-cupos') {
            yield put({ type: actions.EGRESOS_CAJA_TUS_CUPOS, payload: res.data.url });
        }
    }
}

export default function* rootSaga() {
    yield all([
        yield takeEvery(actions.DOWNLOAD_FACTURAS_REQUEST, downloadFacturas),
        yield takeEvery(actions.DOWNLOAD_INFORME_VENTAS_REQUEST, downloadInformeVentas),
        yield takeEvery(actions.DOWNLOAD_REMISIONES_REQUEST, downloadRemisiones),
        yield takeEvery(actions.DOWNLOAD_CAJA_REQUEST, downloadCaja),
        yield takeEvery(actions.DOWNLOAD_INFORME_COMPRAS_REQUEST, downloadInformeCompras),
        yield takeEvery(actions.DOWNLOAD_INFORME_CARTERA_REQUEST, downloadInformeCartera),
        
    ]);
}
